import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import Button from "@atlaskit/button";
import { Field } from "@atlaskit/form";
import TextField from "@atlaskit/textfield";
import { N200 } from "@atlaskit/theme/colors";

import { fontSize, getSwitchAccountUrl } from "@/components/signup/utils";

import { useSiteNameContext } from "../../site-name-context";

export const InputEmail = () => {
    const {
        userInfo: { email }
    } = useSiteNameContext();

    return (
        <div css={wrapperCss}>
            <Field
                isDisabled={true}
                name="email"
                label={
                    <span css={labelCss}>
                        <FormattedMessage
                            id="BxpUiSignup.nameSite.inputEmailLabel"
                            defaultMessage="Work email"
                        />
                    </span>
                }
            >
                {({ fieldProps }) => (
                    <div css={inputCss}>
                        <TextField type="text" {...fieldProps} value={email} />
                    </div>
                )}
            </Field>
            <Button
                appearance="link"
                css={switchAccountCss}
                onClick={() => {
                    window.location.href = getSwitchAccountUrl();
                }}
                spacing="none"
            >
                <FormattedMessage
                    id="BxpUiSignup.nameSite.switchAccountText"
                    defaultMessage="Sign in with a different Atlassian account"
                />
            </Button>
        </div>
    );
};

const inputCss = css({
    marginBlockEnd: "5px",
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- needed to style atlaskit input
    input: {
        // eslint-disable-next-line local/ensure-wac-token-usage
        backgroundColor: "#F2F3F6 !important",
        // eslint-disable-next-line local/ensure-wac-token-usage
        color: "#8590A2",
        fontSize: fontSize.md,
        fontWeight: 400
    }
});

const labelCss = css({
    color: N200,
    display: "block",
    fontSize: fontSize.xs,
    fontWeight: 500
});

const switchAccountCss = css({
    textDecoration: "underline !important"
});

const wrapperCss = css({
    marginBlockEnd: "1.5rem"
});
